import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { TableStateContextProvider } from "../../portal";
import { SettingsDrawerContextProvider } from "@limitless/common/hooks/settings-drawer/SettingsDrawerHook";
import { ExpertAnnouncementsContextProvider } from "../hooks/expert-announcements/ExpertAnnouncementsContext";
import { ExpertPendingFeeAllocationContextProvider } from "../hooks/expert-pending-fee-allocation/ExpertPendingFeeAllocationContext";
import { ExpertPendingQuestionsContextProvider } from "../hooks/expert-pending-questions/ExpertPendingQuestionsContext";
import { ExpertPaymentsContextProvider } from "../hooks/expert-payments/ExpertPaymentsContext";
import { KnowledgeContextProvider } from "../../portal/hooks/knowledge/KnowledgeContext";
import { ExpertOnboardingContextProvider } from "../hooks/expert-onboarding/ExpertOnboardingContext";
import { GuideDrawerContextProvider } from "../../portal/hooks/guide-drawer/GuideDrawerHook";
import { ExpertSupportConversationHistoryContextProvider } from "../hooks/expert-support-conversation-history/ExpertSupportConversationHistoryContext";
import { ExpertAvailableQuestionsContextProvider } from "../hooks/expert-available-questions/ExpertAvailableQuestionsContext";
import { ExpertSupportMessageCreationContextProvider } from "../hooks/expert-support-message-create/ExpertSupportMessageCreationContext";

/** convenience wrapper around some common hooks needed at root level
 *  generally things should go in here that don't require authenication
 */
const ExpertHeaderLifecycleProvider = ({
  children,
  customTranslate,
  ...otherProps
}) => {
  return /*#__PURE__*/React.createElement(ExpertAnnouncementsContextProvider, null, /*#__PURE__*/React.createElement(GuideDrawerContextProvider, null, /*#__PURE__*/React.createElement(SettingsDrawerContextProvider, null, /*#__PURE__*/React.createElement(ExpertPendingFeeAllocationContextProvider, null, /*#__PURE__*/React.createElement(ExpertSupportMessageCreationContextProvider, null, /*#__PURE__*/React.createElement(ExpertSupportConversationHistoryContextProvider, null, /*#__PURE__*/React.createElement(ExpertPendingQuestionsContextProvider, null, /*#__PURE__*/React.createElement(ExpertPaymentsContextProvider, null, /*#__PURE__*/React.createElement(ExpertAvailableQuestionsContextProvider, null, /*#__PURE__*/React.createElement(KnowledgeContextProvider, {
    customTranslate: customTranslate
  }, /*#__PURE__*/React.createElement(ExpertOnboardingContextProvider, null, /*#__PURE__*/React.createElement(TableStateContextProvider, null, /*#__PURE__*/React.cloneElement(children, {
    ...otherProps
  })))))))))))));
};
export default ExpertHeaderLifecycleProvider;
ExpertHeaderLifecycleProvider.propTypes = {
  children: PropTypes.node.isRequired,
  customTranslate: PropTypes.func
};